module.exports = __webpack_public_path__ + "img/Rectangle_39.589e869f.svg";